<template>
  <div>
    <div
      v-if="rootStore.config.allowAanbiedingenOverzicht === 'true'"
      class="xer-flex xer-flex-col xer-items-center"
    >
      <div class="xer-card xer-m-4 xer-flex xer-flex-col xer-items-center">
        <xer-textfield
          class="xer-m-6"
          xer-type="text"
          spellcheck="false"
          autocomplete="off"
          xer-label="Aanbod search"
          :xer-options="aanbodSearchResults"
          :xer-auto-show-options="true"
          :value="aanbodSearchSelected?.label"
          :xer-debounce="300"
          @xer-option-click="aanbodSelected"
          @input="updateAanbiedingenSearch"
        >
          <xer-button
            ref="button"
            xer-type="cta"
            xer-icon="chevron-right"
            :disabled="!aanbodSearchSelected"
            :xer-loading="aanbodSearchLoading"
            @click="$router.push(`/${aanbodSearchSelected.taal}/${aanbodSearchSelected.label}`)"
          />
        </xer-textfield>
        <h1 class="xer-heading-l xer-m-4">Diensten</h1>
        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/Opstart Eenmanszaak"
            data-automation-id="opstart-eenmanszaak"
            >Opstart Eenmanszaak NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/Créer une société"
            data-automation-id="créer-une-societe"
            >Opstart Eenmanszaak FR</router-link
          >
        </div>
        <div>
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/nl/Opstart Eenmanszaak-test"
            data-automation-id="opstart-eenmanszaak-test"
            >Opstart Eenmanszaak Test NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/fr/Créer une société-test"
            data-automation-id="créer-une-societe-test"
            >Opstart Eenmanszaak Test FR</router-link
          >
        </div>

        <div>
          <button
            class="xer-btn xer-btn--warning xer-m-4"
            data-automation-id="opstart-eenmanszaak-hello-bank"
            @click="startHelloBankFlow('nl')"
          >
            Opstart Eenmanszaak Hello Bank NL
          </button>
          <button
            class="xer-btn xer-btn--warning xer-m-4"
            data-automation-id="demarrage-entreprise-personne-physique-hello-bank"
            @click="startHelloBankFlow('fr')"
          >
            Opstart Eenmanszaak Hello Bank FR
          </button>
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/wijzig-sociale-bijdrage"
            data-automation-id="wijzig-sociale-bijdrage"
            >Wijzig sociale bijdrage NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/modification-des-cotisations-sociales"
            data-automation-id="modification-des-cotisations-sociales"
            >Wijzig sociale bijdrage FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/nl/wijzig-sociale-bijdrage-test"
            data-automation-id="wijzig-sociale-bijdrage-test"
            >Wijzig sociale bijdrage Test NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/fr/modification-des-cotisations-sociales-test"
            data-automation-id="modification-des-cotisations-sociales-test"
            >Wijzig sociale bijdrage Test FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/lei-aanvraag"
            data-automation-id="lei-aanvraag"
            >Lei Aanvraag NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/lei-demande"
            data-automation-id="lei-demande"
            >Lei Aanvraag FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/lei-update"
            data-automation-id="lei-update"
            >Lei Update NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/mise-a-jour-lei"
            data-automation-id="mise-a-jour-lei"
            >Lei Update FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/kwijtschelding-verhogingen"
            data-automation-id="kwijtschelding-verhogingen"
            >Kwijtschelding verhogingen NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/renonciation-aux-majorations"
            data-automation-id="renonciation-aux-majorations"
            >Kwijtschelding verhogingen FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/nl/kwijtschelding-verhogingen-test"
            data-automation-id="kwijtschelding-verhogingen-test"
            >Kwijtschelding verhogingen Test NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/fr/renonciation-aux-majorations-test"
            data-automation-id="renonciation-aux-majorations-test"
            >Kwijtschelding verhogingen Test FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/afbetalingsplan"
            data-automation-id="afbetalingsplan"
            >afbetalingsplan NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/plan-de-remboursement"
            data-automation-id="plan-de-remboursement"
            >afbetalingsplan FR</router-link
          >
        </div>
        <div>
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/nl/afbetalingsplan-test"
            data-automation-id="afbetalingsplan-test"
            >afbetalingsplan test NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/fr/plan-de-remboursement-test"
            data-automation-id="plan-de-remboursement-test"
            >afbetalingsplan test FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/vapz-aanvragen"
            data-automation-id="vapz-aanvragen"
            >vapz NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/demander-plci"
            data-automation-id="demander-plci"
            >vapz FR</router-link
          >
        </div>
        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/riziv-overeenkomst-arts"
            data-automation-id="riziv-overeenkomst-arts"
            >riziv overeenkomst (arts) NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/contrat-inami-medecin"
            data-automation-id="riziv-overeenkomst-arts-fr"
            >riziv overeenkomst (arts) FR</router-link
          >
        </div>
        <!--TO-IMPLEMENT rework this screen further -->
        <xer-collapsable>
          <div slot="header" class="xer-flex xer-justify-between xer-flex-grow xer-items-center">
            Andere riziv flows
          </div>
          <div class="xer-card xer-m-4 xer-flex xer-flex-col xer-items-center">
            <div>
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/nl/riziv-overeenkomst-tandarts"
                data-automation-id="riziv-overeenkomst-tandarts"
                >riziv overeenkomst (Tandarts) NL</router-link
              >
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/fr/contrat-inami-dentiste"
                data-automation-id="riziv-overeenkomst-tandarts-fr"
                >riziv overeenkomst (Tandarts) FR</router-link
              >
            </div>
            <div>
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/nl/riziv-overeenkomst-verpleegkundige"
                data-automation-id="riziv-overeenkomst-verpleegkundige"
                >riziv overeenkomst (verpleegkundige) NL</router-link
              >
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/fr/contrat-inami-infirmiers"
                data-automation-id="riziv-overeenkomst-verpleegkundige-fr"
                >riziv overeenkomst (verpleegkundige) FR</router-link
              >
            </div>
            <div>
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/nl/riziv-overeenkomst-kinesist"
                data-automation-id="riziv-overeenkomst-kinesist"
                >riziv overeenkomst (kinesist) NL</router-link
              >
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/fr/contrat-inami-kinesitherapeute"
                data-automation-id="riziv-overeenkomst-kinesist-fr"
                >riziv overeenkomst (kinesist) FR</router-link
              >
            </div>
            <div>
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/nl/riziv-overeenkomst-logopedist"
                data-automation-id="riziv-overeenkomst-logopedist"
                >riziv overeenkomst (logopedist) NL</router-link
              >
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/fr/contrat-inami-logopede"
                data-automation-id="riziv-overeenkomst-logopedist-fr"
                >riziv overeenkomst (logopedist) FR</router-link
              >
            </div>
            <div>
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/nl/riziv-overeenkomst-apotheker"
                data-automation-id="riziv-overeenkomst-apotheker"
                >riziv overeenkomst (apotheker) NL</router-link
              >
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/fr/contrat-inami-pharmaciens"
                data-automation-id="riziv-overeenkomst-apotheker-fr"
                >riziv overeenkomst (apotheker) FR</router-link
              >
            </div>
            <div>
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/nl/riziv-overeenkomst-vroedvrouw"
                data-automation-id="riziv-overeenkomst-vroedvrouw"
                >riziv overeenkomst (vroedvrouw) NL</router-link
              >
              <router-link
                class="xer-btn xer-btn--cta xer-m-4"
                to="/fr/contrat-inami-sage-femme"
                data-automation-id="riziv-overeenkomst-vroedvrouw-fr"
                >riziv overeenkomst (vroedvrouw) FR</router-link
              >
            </div>
          </div>
        </xer-collapsable>
      </div>

      <div class="xer-card xer-m-4 xer-flex xer-flex-col xer-items-center">
        <h1 class="xer-heading-l xer-m-4">Formulieren</h1>
        <div>
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/nl/mijn-unieke-code-aanvragen"
            data-automation-id="mijn-unieke-code-aanvragen"
            >Mijn unieke code aanvragen NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--cta xer-m-4"
            to="/fr/demander-mon-code-unique"
            data-automation-id="demander-mon-code-unique"
            >Mijn unieke code aanvragen FR</router-link
          >
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/nl/informatie-bezorgen"
            data-automation-id="informatie-bezorgen"
            >Informatie doorgeven NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/fr/fournir-des-informations"
            data-automation-id="fournir-des-informations"
            >Informatie doorgeven FR</router-link
          >
        </div>

        <div>
          <button
            class="xer-btn xer-btn--cta xer-m-4"
            data-automation-id="bankrekeningnummer-doorgeven"
            @click="startRekeningnummerDoorgevenFlow('nl')"
          >
            Bankrekeningnummer doorgeven NL
          </button>
          <button
            class="xer-btn xer-btn--cta xer-m-4"
            data-automation-id="numero-de-compte-bancaire-envoyer"
            @click="startRekeningnummerDoorgevenFlow('fr')"
          >
            Bankrekeningnummer doorgeven FR
          </button>
        </div>

        <div>
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/nl/mijn-unieke-code-aanvragen-test"
            data-automation-id="mijn-unieke-code-aanvragen-test"
            >Mijn unieke code aanvragen test NL</router-link
          >
          <router-link
            class="xer-btn xer-btn--warning xer-m-4"
            to="/fr/demander-mon-code-unique-test"
            data-automation-id="demander-mon-code-unique-test"
            >Mijn unieke code aanvragen test FR</router-link
          >
        </div>
      </div>
      <div class="xer-card xer-m-4 xer-flex xer-flex-col xer-items-center">
        <h1 class="xer-heading-l xer-m-4">Generieke Diensten</h1>
        <div class="xer-card xer-m-4 xer-flex xer-flex-col xer-items-center">
          <div>
            <router-link
              class="xer-btn xer-btn--cta xer-m-4"
              to="/nl/machtiging-ambulante-handel-als-aangestelde-A-nieuw"
              data-automation-id="machtiging-ambulante-handel-als-aangestelde-A-nieuw"
              >machtiging ambulante handel aangestelde A</router-link
            >
            <router-link
              class="xer-btn xer-btn--cta xer-m-4"
              to="/fr/autorisation-dactivits-ambulantes--prpos-a-nouvelle-demande"
              data-automation-id="machtiging-ambulante-handel-als-aangestelde-A-nieuw-fr"
              >machtiging ambulante handel aangestelde A FR</router-link
            >
          </div>
          <div>
            <router-link
              class="xer-btn xer-btn--cta xer-m-4"
              to="/nl/machtiging-ambulante-handel-als-aangestelde-B-nieuw"
              data-automation-id="machtiging-ambulante-handel-als-aangestelde-B-nieuw"
              >machtiging ambulante handel aangestelde B</router-link
            >
            <router-link
              class="xer-btn xer-btn--cta xer-m-4"
              to="/fr/autorisation-dactivits-ambulantes--prpos-b-nouvelle-demande"
              data-automation-id="machtiging-ambulante-handel-als-aangestelde-B-nieuw-fr"
              >machtiging ambulante handel aangestelde B FR</router-link
            >
          </div>
          <div>
            <router-link
              class="xer-btn xer-btn--cta xer-m-4"
              to="/nl/via-xerius-test-aanbod-1--ol"
              data-automation-id="via-xerius-test-aanbod-1--ol"
              >Test aanbod 1 - OL - Persoon</router-link
            >
          </div>
          <div>
            <router-link
              class="xer-btn xer-btn--cta xer-m-4"
              to="/nl/via-xerius-test-aanbod-2--svz"
              data-automation-id="via-xerius-test-aanbod-2--svz"
              >Test aanbod 2 - SVZ - Onderneming</router-link
            >
          </div>
        </div>
      </div>

      <div class="xer-card xer-m-4 xer-flex xer-flex-col xer-items-center">
        <h1 class="xer-heading-l xer-m-4">Concepts</h1>
        <div>
          <router-link class="xer-btn xer-m-4" to="/nl/subsidie-poc" data-automation-id="subsidie"
            >Subsidie NL</router-link
          >
          <router-link
            class="xer-btn xer-m-4"
            to="/fr/subsidie-poc-fr"
            data-automation-id="subsidie-fr"
            >Subsidie FR</router-link
          >
        </div>

        <router-link
          class="xer-btn xer-m-4"
          to="/nl/Content Components Flow"
          data-automation-id="aanbod-content-component-flow"
          >Content Components Flow</router-link
        >

        <router-link
          class="xer-btn xer-m-4"
          to="/nl/visual-testing"
          data-automation-id="aanbod-visual-testing"
          >Visual Testing</router-link
        >

        <router-link
          class="xer-btn xer-m-4"
          to="/nl/fake-aanbod-generieke-dienst-test"
          data-automation-id="fake-aanbod-generieke-dienst-test"
          >Fake aanbod generieke diensten</router-link
        >
      </div>
    </div>
    <div v-else>
      <oeps error-component="XerNotFound" />
    </div>
  </div>
</template>

<script>
import Oeps from '@/views/Oeps';
import leadAanvraagApi from '@/api/lead-aanvraag.api';
import aanbodIndexApi from '@/api/aanbod-index.api';
import aanbodApi from '@/api/aanbod.api';
import XerCollapsable from '@/components/XerCollapsable.vue';
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';
import { XerTextfield, XerButton } from '@xerius/codey-components-vue2';

export default {
  name: 'Aanbiedingen',
  components: {
    Oeps,
    XerCollapsable,
    XerTextfield,
    XerButton
  },
  data() {
    return {
      aanbodSearchResults: [],
      aanbodSearchSelected: undefined,
      aanbodSearchLoading: false
    };
  },
  computed: {
    ...mapStores(useRootStore)
  },
  methods: {
    async startAanbodWithApi(aanbod, lang, data) {
      const aanbodDefinitie = await aanbodApi.getAanbodDefinitie(lang, aanbod);
      const response = await leadAanvraagApi.postLeadAanvraagFull(lang, {
        aanbodType: aanbodDefinitie.aanbodType,
        ...data
      });

      // Support local development usage
      if (window.location.href.indexOf('localhost') > 0) {
        let replaceWith = 'localhost:8080';
        if (window.location.href.indexOf('localhost:28118') > 0) {
          replaceWith = 'localhost:28118';
        }

        window.location = response.headers.location.replace(
          'dev-app.xerius.be/ViaXerius',
          replaceWith
        );
      } else {
        window.location = response.headers.location;
      }
    },
    async startHelloBankFlow(lang) {
      const aanbod =
        lang == 'nl'
          ? 'opstart-eenmanszaak-hello-bank'
          : 'demarrage-entreprise-personne-physique-hello-bank';

      await this.startAanbodWithApi(aanbod, lang, {
        persoon: {
          voornaam: 'hello',
          achternaam: 'bank',
          telefoonnummer: '0474/65.53.48',
          email: 'hello@example.com'
        },
        onderneming: {
          vestiging: {
            bedrijfsnaam: 'Hello Bank',
            geenBedrijfsnaam: false
          }
        }
      });
    },
    async startRekeningnummerDoorgevenFlow(lang) {
      const aanbod =
        lang == 'nl' ? 'bankrekeningnummer-doorgeven' : 'numero-de-compte-bancaire-envoyer';

      await this.startAanbodWithApi(aanbod, lang, {
        customData: {
          redirectUrl: window.location.href,
          cancelUrl: window.location.href
        }
      });
    },

    async updateAanbiedingenSearch(input) {
      if (this.cancelToken) {
        this.cancelToken.cancel();
      }

      this.aanbodSearchSelected = undefined;
      if (!input) {
        this.aanbodSearchResults = [];
        this.aanbodSearchLoading = false;
        return;
      }

      this.cancelToken = this.axios.CancelToken.source();

      this.aanbodSearchLoading = true;
      try {
        this.aanbodSearchResults = await aanbodIndexApi.getBySearchTerm(
          input,
          this.cancelToken.token
        );
        this.aanbodSearchResults = this.aanbodSearchResults.map((a) => {
          return {
            label: a.aanbodNaam,
            value: a.aanbodNaam,
            taal: a.aanbodTaal == 1 ? 'fr' : 'nl'
          };
        });
      } catch {
        //Do nothing, we don't want the entire page to fail because of this
      } finally {
        this.aanbodSearchLoading = false;
      }
    },
    aanbodSelected(aanbod) {
      this.aanbodSearchSelected = aanbod;
      this.aanbiedingSearchResults = [];
    }
  }
};
</script>

<style lang="scss">
@import '~@xerius/codey-style-vue2/theme/_theme.scss';

.xer-btn--warning {
  background-color: $xer-warning !important;
  border-color: darken($color: $xer-warning, $amount: 10) !important;
}
</style>
